import { SupportedMessageFormats } from "../../../Contracts";
import { SDQuerySubscribersStore } from "../SDQuerySubscribersStore";
import { formats } from "../../../Common";
export function SDQResponseFormatter(payload) {
    const p = JSON.parse(payload.data);
    if (p.result === "Unsubscribed") {
        return { channel: "Unsubscribed", result: {} };
    }
    const q = SDQuerySubscribersStore.getQueryByID(p.id);
    return formats[SupportedMessageFormats["jsonrpc2.0"]](p, q);
}
//# sourceMappingURL=SDQResponseFormatter.js.map